<template>
    <div>
        <skeleton-screen-card v-if="!isCloseSkeletonScreen" :data="3" />
        <div
            v-if="isCloseSkeletonScreen && stockList && stockList.length > 0 && !loading"
            class="stockListWrap"
        >
            <div
                v-for="(item, index) in stockList"
                class="stockListItem"
                :key="index"
                @click.stop.prevent="handleClickToStockPage(item)"
            >
                <div class="stockListLeft">
                    <div class="stockListInfo">
                        <h1>{{ item.name }}</h1>
                        <p>{{stockName(item.code)}}</p>
                    </div>
                    <div class="stockListPrice">
                        <p :class="[{
                            bindRed: item.chg_pct && item.chg_pct != '--' && item.chg_pct > 0,
                            bindGreen: item.chg_pct && item.chg_pct != '--' && item.chg_pct < 0
                        }]">{{item.last}}</p>
                    </div>
                </div>
                <div
                    :class="['stockListRight', {
                    bindRed: item.chg_pct && (item.chg_pct > 0 && item.chg_pct != '--'),
                    bindGreen: item.chg_pct && (item.chg_pct < 0 && item.chg_pct != '--')
                }]">
                    <span v-if="item.chg_pct && item.chg_pct != 0 && item.chg_pct != '--'">{{ item.chg_pct && item.chg_pct > 0? "+": "" }}{{ item.chg_pct && item.chg_pct }}%</span>
                    <span v-else>--</span>
                </div>                
            </div>
        </div>
        <no-result v-if="isCloseSkeletonScreen && stockList.length == 0 && !loading" title="暂无内容~"></no-result>
    </div>
</template>
<script>
import { isGoUp } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
export default {
    name: "UserProfiles",
    components: {
        noResult: () => import("@/components/userHome/components/noResult.vue"),
        skeletonScreenCard: () => import("@/components/userHome/components/skeletonScreen.vue")
    },
    props: {
        teacherInfo: {
            type: Object,
            default: ()=> {
                return {}
            }
        },
		list: {
			type: Array,
			default: ()=>{
				return []
			}
		}
    },
    data() {
        return {
            stockList: [],
            loading: true,
            isCloseSkeletonScreen: false,
            user_id: parseInt(this.$route.query.user_id)
        };
    },
    created() {
		if(this.list && this.list.length > 0) {
			this.stockList = this.list;
			this.isCloseSkeletonScreen = true;
			this.loading = false;
		} else {
			this.getConsumerCombination();
		}
        
    },
    methods: {
        columnListMore() {
            if (this.hasMore) return;
        },
        reloadList() {
            this.stockList = [];
            //获取用户全部数据
            this.getConsumerCombination('close');
        },
        //用户个人主页  组合
        async getConsumerCombination(type) {
            // cuser_id=44324&act=get_stock_list&user_id=24&format=json&type=edit_all&version=3
            let data = await userHomeApi.getUserStock({
                cuser_id: this.teacherInfo.u_id,
                act: "get_stock_list",
                format: "json",
                type: "edit_all",
                version: 3,
            });
            if (data.rslt == 'succ' && data.stock_list.length > 0) {
                let result = data.stock_list;
                this.stockList = result;
            }
            this.isCloseSkeletonScreen = true;
            this.loading = false;
            
            if(type) {
                this.$srH5CallNativeMethodApp('refresh_done',{})
            }
            // this.$emit("scrollRefresh");
        },
        stockName(code) {
            const regex = /^(SH|SZ|BJ|NQ|US|HK|ZH)\d{6}$/i;
            if(regex.test(code)) {
                code = code.toUpperCase();
                if(code.length > 2) {
                    return code.slice(0, 2) + "."+code.slice(2);
                } else {
                    return code;
                }
            } else {
                return code;
            }
        },
        // 点击事件 - 跳转详情页
        handleClickToStockPage(item) {
            if(item.code.indexOf("BK") > -1 || item.code.indexOf("bk") > -1) {
                let id = 0;
                if(item.code.indexOf("BK") > -1) {
                    id = item.code.split("BK")[1] * 1;
                }
                if(item.code.indexOf("bk") > -1) {
                    id = item.code.split("bk")[1] * 1;
                }
                this.openNative('theme_page', {
                    id: id
                })
            } else {
                this.openNative('stock_page', {
                    name: item.name,
                    code: item.code
                })
            }
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "stock_page": // 股票详情页
                    break;
                case "theme_page": // 板块详情页
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .stockListWrap {
        width: 100%;
        height: auto;

        .stockListItem {
            width: 100%;
            padding: 8px 12px;
            box-sizing: border-box;
            height: auto;
            display: flex;
            flex-direction: row;
            border-bottom: 0.5px solid #EBEBEB;

            .stockListLeft {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                padding-right: 75.5px;
                box-sizing: border-box;

                .stockListInfo {

                    h1 {
                        color: $a-normal;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px; /* 125% */
                    }

                    p {
                        color: #939393;
                        font-size: 13px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px; /* 153.846% */
                        margin-top: 1.5px;
                    }
                }

                .stockListPrice {
                    margin-left: auto;
                    padding-top: 7px;
                    box-sizing: border-box;

                    p {
                        color: #7F8E9D;
                        text-align: right;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 20px; /* 125% */

                        &.bindRed {
                            color: #CB382D;
                        }

                        &.bindGreen {
                            color: #659957;
                        }
                    }
                }
            }
         
            .stockListRight {
                margin-top: 4px;
                width: 81px;
                height: 31px;
                border-radius: 3px;
                background-color: #7F8E9D;
                text-align: center;
                display: inline-flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                &.bindRed {
                    background-color: #FE484A;
                }

                &.bindGreen {
                    background-color: #0AC890;
                }

                span {
                    color: #FFF;
                    text-align: center;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                }
            }
        }
    }
</style>